/**
 * Tiny pub-sub used to bridge the FrameFloatingToolbar's "edit title"
 * button (mounted up at the engine layer via SelectionTransformer) to
 * the Frame Component's local edit-mode state.
 *
 * Why not React context: the toolbar is not a descendant of the Frame
 * Component — it's mounted by SelectionTransformer's NodeToolbar
 * portal. Why not Yjs awareness: edit-mode is a purely local UI flag,
 * not collaborative state worth syncing.
 *
 * Usage:
 *   - FrameFloatingToolbar:    `requestEditTitle(nodeId)` on click
 *   - Frame Component:        `subscribeEditTitle(nodeId, onRequest)`
 */
type Listener = () => void;
const listeners = new Map<string, Set<Listener>>();

export function requestEditTitle(nodeId: string): void {
  listeners.get(nodeId)?.forEach((cb) => cb());
}

export function subscribeEditTitle(nodeId: string, cb: Listener): () => void {
  let set = listeners.get(nodeId);
  if (!set) { set = new Set(); listeners.set(nodeId, set); }
  set.add(cb);
  return () => {
    set!.delete(cb);
    if (set!.size === 0) listeners.delete(nodeId);
  };
}
